#!/usr/bin/env node

import { LLMail } from '../LLMail';
import yargs from 'yargs';
import { hideBin } from 'yargs/helpers';

async function main() {
  const argv = yargs(hideBin(process.argv))
    .usage('Usage: $0 <id> [options]')
    .option('update', {
      alias: 'u',
      type: 'string',
      description: 'The update text to add',
      demandOption: true
    })
    .option('state', {
      alias: 's',
      type: 'string',
      description: 'State to update the item with'
    })
    .option('frontmatter', {
      alias: 'f',
      type: 'string',
      description: 'JSON string representing additional frontmatter metadata'
    })
    .option('append', {
      type: 'boolean',
      description: 'Append update to the bottom instead of prepending'
    })
    .demandCommand(1, 'You must provide the id of the item to update')
    .help()
    .parseSync();

  // Get the positional argument 'id'
  const id = argv._[0] as string;
  const updateText = argv.update;

  // Build metadata object
  const metadata: any = {};
  if (argv.state) {
    metadata.state = argv.state;
  }
  if (argv.frontmatter) {
    try {
      Object.assign(metadata, JSON.parse(argv.frontmatter));
    } catch (err) {
      console.error('Error parsing frontmatter JSON:', err);
      process.exit(1);
    }
  }

  const llmail = new LLMail();
  try {
    await llmail.init();  // Initialize LLMail first
    if (argv.append) {
      await llmail.appendUpdate(id, updateText, metadata, true);
      console.log(`Update appended to item ${id} successfully.`);
    } else {
      await llmail.prependUpdate(id, updateText, metadata, true);
      console.log(`Update prepended to item ${id} successfully.`);
    }
  } catch (err) {
    console.error('Error updating item:', err);
    process.exit(1);
  }
}

main();